import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";

const NineBoxGrid = React.lazy(() =>
  import("@/pages/successionPlan/NineBoxGrid")
);
const HRTab = React.lazy(() =>
  import("@/pages/successionPlan/CommonTab/HRTab")
);
const DHTab = React.lazy(() =>
  import("@/pages/successionPlan/CommonTab/DHTab")
);

const SuccessionPlan = [
  {
    path: "NineBoxGrid",
    element: (
      <SuspenseWrapper>
        <NineBoxGrid />
      </SuspenseWrapper>
    ),
  },
  {
    path: "successionPlan",
    element: (
      <SuspenseWrapper>
        <HRTab />
      </SuspenseWrapper>
    ),
  },
  {
    path: "DHSuccessionPlan",
    element: (
      <SuspenseWrapper>
        <DHTab />
      </SuspenseWrapper>
    ),
  },
];

export default SuccessionPlan;
